<script>
import HistoricoFuncional from '@/components/historicoFuncional/HistoricoFuncional.vue'

export default {
  extends: HistoricoFuncional,
}
</script>
